import { render, staticRenderFns } from "./worksList.vue?vue&type=template&id=79716f20&"
import script from "./worksList.vue?vue&type=script&lang=js&"
export * from "./worksList.vue?vue&type=script&lang=js&"
import style0 from "./worksList.vue?vue&type=style&index=0&id=79716f20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports